import * as React from 'react';
import { Image, ImageResizeOptions } from '../Image';
import { classes, st } from './HeroImage.st.css';
/** HeroImage is a component representing a header with high presence providing context about the page content */
export class HeroImage extends React.Component {
    render() {
        const { className, ...imageProps } = this.props;
        return React.createElement(Image, { className: st(classes.root, className), ...imageProps });
    }
}
HeroImage.displayName = 'HeroImage';
HeroImage.defaultProps = {
    resize: ImageResizeOptions.cover,
};
//# sourceMappingURL=HeroImage.js.map